import styled, { css } from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";

export const Wrapper = styled.div`
  align-items: center;
  border: 1px solid ${colors.GRAY_LIGHT};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  height: 63px;
  position: relative;
  width: 400px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 101px;
    width: 100%;
  }
`;

export const InfoBox = styled.div`
  padding: 0 0 0 18px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    margin: -27px 0 0 0;
  }
`;

export const Actions = styled.div`
  align-items: center;
  display: flex;
  position: absolute;
  right: 14px;
  top: 18px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    bottom: 13px;
    left: 116px;
    right: auto;
    top: auto;
  }
}
`;

export const OHTime = styled(typography.Body)`
  align-items: baseline;
  background: ${props =>
    props.isHiglight ? colors.NOTICE_LIGHTEST : "transparent"};
  display: flex;

  ${({ isHiglight }) =>
    isHiglight &&
    css`
      margin: 0 -2px;
      padding: 0 2px;
    `}

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    line-height: 17px;
  }
`;

export const Link = styled(TextAction).attrs({
  typography: textActionTypography.BODY,
  underlined: false
})`
  display: inline-block;
  max-width: 174px;
  overflow: hidden;
  text-decoration: ${props => (props.isCanceled ? "line-through" : "none")};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveIcon = styled.i.attrs({
  className: "fa fa-times"
})`
  font-size: 13px;
  color: ${colors.TEXT_SECONDARY};

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    margin: -1px 0 0 0;
  }
`;

export const RemoveButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  align-items: center;
  background: none;
  border: none;
  border-left: 1px solid ${colors.GRAY_LIGHT};
  color: ${colors.TEXT_SECONDARY};
  display: flex;
  height: auto;
  margin: 4px 0 0 -3px;
  min-width: auto;
  padding: 0 0 0 6px;

  &:focus {
    background: none;
    border: none;
    border-left: 1px solid ${colors.GRAY_LIGHT};
  }

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    align-items: center;
    border: none;
    display: flex;
    margin: 0 0 0 -1px;
    padding: 0;

    &:after {
      content: "remove";
      display: inline-block;
      padding: 0 0 0 4px;
    }

    &:focus {
      background: none;
      border: none;
    }
  }
`;

export const ListingImage = styled.img.attrs({
  alt: "",
  "aria-hidden": true
})`
  display: block;
  height: 63px;
  object-fit: cover;
  width: 63px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 100px;
    width: 100px;
  }
`;

export const AddToCalendarWrapper = styled.div`
  display: inline-block;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    display: none;
  }
`;

export const Confirmation = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  margin: 9px 0 0;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    text-align: right;
  }
`;

export const GotItButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  background: none;
  border: none;
  color: ${colors.BRAND};
  display: inline-block;
  height: auto;
  min-width: auto;
  padding: 0 0 0 5px;

  &:focus {
    background: none;
    border: none;
  }
`;

export const Notice = styled.span`
  color: ${props => (props.isError ? colors.ERROR : colors.NOTICE)};
  font-size: 12px;
  padding: 0 0 0 5px;
`;

export const OHTimeText = styled.span`
  text-decoration: ${props => (props.isCanceled ? "line-through" : "none")};
`;

export const ImageLinkWrapper = styled.a``;
